if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          mobileArrows: this.querySelector('.mobile-media-arrows'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        
        // Add mobile arrow functionality
        if (this.elements.mobileArrows) {
          this.prevArrow = this.elements.mobileArrows.querySelector('.mobile-media-arrow--prev');
          this.nextArrow = this.elements.mobileArrows.querySelector('.mobile-media-arrow--next');
          
          if (this.prevArrow) {
            this.prevArrow.addEventListener('click', this.navigateSlider.bind(this, 'previous'));
          }
          if (this.nextArrow) {
            this.nextArrow.addEventListener('click', this.navigateSlider.bind(this, 'next'));
          }
          
          // Initialize arrow states
          this.updateArrowStates();
        }
        
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.updateArrowStates();
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        this.updateArrowStates();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      updateArrowStates() {
        if (!this.elements.mobileArrows || !this.prevArrow || !this.nextArrow) return;
        
        const activeSlide = this.elements.viewer.querySelector('.product__media-item.is-active');
        if (!activeSlide) return;
        
        const allSlides = this.elements.viewer.querySelectorAll('.product__media-item');
        let sliderCounter = document.querySelector(".slider-counter--current");
        if(!sliderCounter) return console.log("Slider Counter not found");
        let currentIndex = parseInt(sliderCounter.textContent, 10) - 1;
        const totalSlides = allSlides.length;
        
        // Update previous arrow
        if (currentIndex === 0) {
          this.prevArrow.classList.add('mobile-media-arrow--disabled');
        } else {
          this.prevArrow.classList.remove('mobile-media-arrow--disabled');
        }
        
        // Update next arrow
        if (currentIndex === totalSlides - 1) {
          this.nextArrow.classList.add('mobile-media-arrow--disabled');
        } else {
          this.nextArrow.classList.remove('mobile-media-arrow--disabled');
        }
      }

      navigateSlider(direction) {
        // Use the existing slider component functionality
        const viewerSlider = this.elements.viewer;
        if (!viewerSlider || !viewerSlider.slider) return;
        
        const button = viewerSlider.querySelector(`button[name="${direction === 'previous' ? 'previous' : 'next'}"]`);
        if (button) {
          //button.click();
          // Update arrow states after navigation
          setTimeout(() => this.updateArrowStates(), 100);
        }
      }
    }
  );
}
